/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartBarsXUpIcon20Regular = forwardRef('DataChartBarsXUpIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M16 2.75a.75.75 0 0 1 .75.75v10.719a.75.75 0 0 1-1.5 0V3.5a.75.75 0 0 1 .75-.75Z" }),
        React.createElement("path", { d: "M12.75 6a.75.75 0 0 0-1.5 0v8.219a.75.75 0 0 0 1.5 0V6Z" }),
        React.createElement("path", { d: "M4 10a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 4 10Z" }),
        React.createElement("path", { d: "M1.25 18a.75.75 0 0 1 .75-.75h16a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1-.75-.75Z" }),
        React.createElement("path", { d: "M8.75 8.35a.75.75 0 0 0-1.5 0v5.869a.75.75 0 0 0 1.5 0V8.35Z" })));
});
